import { render, staticRenderFns } from "./UserChangePasswordDialog.vue?vue&type=template&id=7005a8c7&scoped=true"
import script from "./UserChangePasswordDialog.vue?vue&type=script&lang=ts"
export * from "./UserChangePasswordDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7005a8c7",
  null
  
)

export default component.exports